const t = {}

t.loading = '加载中...'

t.brand = {}
t.brand.lg = '巴斯夫调漆宝管理系统'
t.brand.BASF_REFINISHHUB_MANAGEMENT_PORTAL = '巴斯夫调漆宝管理系统'
t.brand.mini = 'BASF'
t.brand.oem = '制造商'
t.brand.carLine = '品牌'
t.brand.carModel = '车型'

t.add = '新增'
t.forgot_password = '忘记密码'
t.Invitation_register = '邀请注册'
t.Invote_register = '邀请注册'
t.delete = '删除'
t.deleteBatch = '删除'
t.syncRecipe = '同步至App端'
t.massiveUpload = '批量上传'
t.update = '修改'
t.query = '查询'
t.export = '导出'
t.handle = '操作'
t.confirm = '确定'
t.finish = '完成'
t.cancel = '取消'
t.clear = '清除'
t.logout = '退出'
t.manage = '处理'
t.createDate = '创建时间'
t.keyword = '关键字：'
t.choose = '请选择'
t.veiew = '查看'

t.prompt = {}
t.prompt.title = '提示'
t.prompt.info = '确定进行[{handle}]操作?'
t.prompt.success = '操作成功'
t.prompt.failed = '操作失败'
t.prompt.deleteBatch = '请选择删除项'
t.prompt.sycBatch = '请选择同步到App的配方'

t.validate = {}
t.validate.required = '必填项不能为空'
t.validate.scanCodeRequired = "第{index}条 中规则时间、品牌、产品线、SKU 至少选填一项"
t.validate.extraPointRequired = "第{index}条 额外积分为空"
t.validate.format = '{attr}格式错误'

t.upload = {}
t.upload.text = '将文件拖到此处，或<em>点击上传</em>'
t.upload.clickText = '点击上传'
t.upload.tip = '只支持{format}格式文件！'
t.upload.button = '点击上传'

t.datePicker = {}
t.datePicker.range = '至'
t.datePicker.start = '开始日期'
t.datePicker.end = '结束日期'

t.fullscreen = {}
t.fullscreen.prompt = '您的浏览器不支持此操作'

t.updatePassword = {}
t.updatePassword.title = '修改密码'
t.updatePassword.username = '账号'
t.updatePassword.password = '原密码'
t.updatePassword.newPassword = '新密码'
t.updatePassword.confirmPassword = '确认密码'
t.updatePassword.validate = {}
t.updatePassword.validate.confirmPassword = '确认密码与新密码输入不一致'
t.updatePassword.validate.complexityPassword = '您的密码复杂度太低（密码必须由字母、数字组成,长度8-20位）'

t.contentTabs = {}
t.contentTabs.closeCurrent = '关闭当前标签页'
t.contentTabs.closeOther = '关闭其它标签页'
t.contentTabs.closeAll = '关闭全部标签页'

/* 页面 */
t.notFound = {}
t.notFound.desc = '抱歉！您访问的页面<em>失联</em>啦...'
t.notFound.back = '上一页'
t.notFound.home = '首页'

t.noAccess = {}
t.noAccess.desc = '抱歉！您没有<em>权限</em>访问该页面/功能...'
t.noAccess.back = '上一页'
t.noAccess.home = '首页'

t.login = {}
t.login.lang = '中文/EN'
t.login.title = '登录'
t.login.register = '用户注册'
t.login.username = '用户名/手机号'
t.login.password = '密码'
t.login.captcha = '验证码'
t.login.send_code = '发送验证码',
t.login.demo = '在线演示'
t.login.mobile = '手机号'
t.login.copyright = '人人开源'
t.login.please_select_data = '请至少选择一条列表数据'

t.schedule = {}
t.schedule.beanName = 'bean名称'
t.schedule.beanNameTips = 'spring bean名称, 如: testTask'
t.schedule.pauseBatch = '暂停'
t.schedule.resumeBatch = '恢复'
t.schedule.runBatch = '执行'
t.schedule.log = '日志列表'
t.schedule.params = '参数'
t.schedule.cronExpression = 'cron表达式'
t.schedule.cronExpressionTips = '如: 0 0 12 * * ?'
t.schedule.remark = '备注'
t.schedule.status = '状态'
t.schedule.status0 = '暂停'
t.schedule.status1 = '正常'
t.schedule.statusLog0 = '失败'
t.schedule.statusLog1 = '成功'
t.schedule.pause = '暂停'
t.schedule.resume = '恢复'
t.schedule.run = '执行'
t.schedule.jobId = '任务ID'
t.schedule.times = '耗时(单位: 毫秒)'
t.schedule.createDate = '执行时间'

t.oss = {}
t.oss.config = '云存储配置'
t.oss.upload = '上传文件'
t.oss.url = 'URL地址'
t.oss.createDate = '创建时间'
t.oss.type = '类型'
t.oss.type1 = '七牛'
t.oss.type2 = '阿里云'
t.oss.type3 = '腾讯云'
t.oss.qiniuDomain = '域名'
t.oss.qiniuDomainTips = '七牛绑定的域名'
t.oss.qiniuPrefix = '路径前缀'
t.oss.qiniuPrefixTips = '不设置默认为空'
t.oss.qiniuAccessKey = 'AccessKey'
t.oss.qiniuAccessKeyTips = '七牛AccessKey'
t.oss.qiniuSecretKey = 'SecretKey'
t.oss.qiniuSecretKeyTips = '七牛SecretKey'
t.oss.qiniuBucketName = '空间名'
t.oss.qiniuBucketNameTips = '七牛存储空间名'
t.oss.aliyunDomain = '域名'
t.oss.aliyunDomainTips = '阿里云绑定的域名，如：http://cdn.renren.io'
t.oss.aliyunPrefix = '路径前缀'
t.oss.aliyunPrefixTips = '不设置默认为空'
t.oss.aliyunEndPoint = 'EndPoint'
t.oss.aliyunEndPointTips = '阿里云EndPoint'
t.oss.aliyunAccessKeyId = 'AccessKeyId'
t.oss.aliyunAccessKeyIdTips = '阿里云AccessKeyId'
t.oss.aliyunAccessKeySecret = 'AccessKeySecret'
t.oss.aliyunAccessKeySecretTips = '阿里云AccessKeySecret'
t.oss.aliyunBucketName = 'BucketName'
t.oss.aliyunBucketNameTips = '阿里云BucketName'
t.oss.qcloudDomain = '域名'
t.oss.qcloudDomainTips = '腾讯云绑定的域名'
t.oss.qcloudPrefix = '路径前缀'
t.oss.qcloudPrefixTips = '不设置默认为空'
t.oss.qcloudAppId = 'AppId'
t.oss.qcloudAppIdTips = '腾讯云AppId'
t.oss.qcloudSecretId = 'SecretId'
t.oss.qcloudSecretIdTips = '腾讯云SecretId'
t.oss.qcloudSecretKey = 'SecretKey'
t.oss.qcloudSecretKeyTips = '腾讯云SecretKey'
t.oss.qcloudBucketName = 'BucketName'
t.oss.qcloudBucketNameTips = '腾讯云BucketName'
t.oss.qcloudRegion = '所属地区'
t.oss.qcloudRegionTips = '请选择'
t.oss.qcloudRegionBeijing1 = '北京一区（华北）'
t.oss.qcloudRegionBeijing = '北京'
t.oss.qcloudRegionShanghai = '上海（华东）'
t.oss.qcloudRegionGuangzhou = '广州（华南）'
t.oss.qcloudRegionChengdu = '成都（西南）'
t.oss.qcloudRegionChongqing = '重庆'
t.oss.qcloudRegionSingapore = '新加坡'
t.oss.qcloudRegionHongkong = '香港'
t.oss.qcloudRegionToronto = '多伦多'
t.oss.qcloudRegionFrankfurt = '法兰克福'

t.dept = {}
t.dept.id = '商户ID'
t.dept.name = '名称'
t.dept.deptTypeName = '商户类型'
t.dept.email = '管理员邮箱'
t.dept.paintLineName = '油漆品牌'
t.dept.parentName = '上级部门'
t.dept.sort = '排序'
t.dept.parentNameDefault = '一级部门'
t.dept.chooseerror = '请选择部门'
t.dept.title = '选择部门'

t.dict = {}
t.dict.dictName = '字典名称'
t.dict.dictType = '字典类型'
t.dict.dictLabel = '字典标签'
t.dict.dictValue = '字典值'
t.dict.sort = '排序'
t.dict.remark = '备注'
t.dict.createDate = '创建时间'

t.logError = {}
t.logError.requestUri = '请求URI'
t.logError.requestMethod = '请求方式'
t.logError.requestParams = '请求参数'
t.logError.ip = '操作IP'
t.logError.userAgent = '用户代理'
t.logError.createDate = '创建时间'
t.logError.errorInfo = '异常信息'

t.logLogin = {}
t.logLogin.creatorName = '用户名'
t.logLogin.status = '状态'
t.logLogin.status0 = '失败'
t.logLogin.status1 = '成功'
t.logLogin.status2 = '账号已锁定'
t.logLogin.operation = '操作类型'
t.logLogin.operation0 = '登录'
t.logLogin.operation1 = '退出'
t.logLogin.ip = '操作IP'
t.logLogin.userAgent = 'User-Agent'
t.logLogin.createDate = '创建时间'

t.logOperation = {}
t.logOperation.status = '状态'
t.logOperation.status0 = '失败'
t.logOperation.status1 = '成功'
t.logOperation.creatorName = '用户名'
t.logOperation.operation = '用户操作'
t.logOperation.requestUri = '请求URI'
t.logOperation.requestMethod = '请求方式'
t.logOperation.requestParams = '请求参数'
t.logOperation.requestTime = '请求时长'
t.logOperation.ip = '操作IP'
t.logOperation.userAgent = 'User-Agent'
t.logOperation.createDate = '创建时间'

t.menu = {}
t.menu.name = '名称'
t.menu.icon = '图标'
t.menu.type = '类型'
t.menu.type0 = '菜单'
t.menu.type1 = '按钮'
t.menu.sort = '排序'
t.menu.url = '路由'
t.menu.permissions = '授权标识'
t.menu.permissionsTips = '多个用逗号分隔，如：sys:menu:save,sys:menu:update'
t.menu.parentName = '上级菜单'
t.menu.parentNameDefault = '一级菜单'
t.menu.resource = '授权资源'
t.menu.resourceUrl = '资源URL'
t.menu.resourceMethod = '请求方式'
t.menu.resourceAddItem = '添加一项'

t.params = {}
t.params.paramCode = '编码'
t.params.paramValue = '值'
t.params.remark = '备注'

t.role = {}
t.role.name = '名称'
t.role.remark = '备注'
t.role.createDate = '创建时间'
t.role.menuList = '菜单授权'
t.role.deptList = '数据授权'
t.role.type = '角色类型'

t.user = {}
t.user.username = '用户名'
t.user.role = '用户角色'
t.user.deptName = '所属商户'
t.user.email = '邮箱'
t.user.mobile = '手机号'
t.user.status = '状态'
t.user.status0 = '停用'
t.user.status1 = '正常'
t.user.createDate = '创建时间'
t.user.password = '密码'
t.user.confirmPassword = '确认密码'
t.user.realName = '真实姓名'
t.user.gender = '性别'
t.user.gender0 = '男'
t.user.gender1 = '女'
t.user.gender2 = '保密'
t.user.roleIdList = '角色配置'
t.user.validate = {}
t.user.validate.confirmPassword = '确认密码与密码输入不一致'
t.user.select = '选择用户'
t.user.selecterror = '请选择一条记录'
t.user.adduser='增加用户'
t.user.id_sub_dealer = '经销商'
t.user.body_shop = '4S店'
t.user.sendangin = '重新发送'

t.user.commentStatus ='评论状态'
t.user.allow = '允许',
t.user.forbid = '禁止',
t.user.forbiddenUntil = '禁止到期日'
t.user.selectDate = '选择日期'
t.user.forbidReason = '禁止原因'
t.user.forbidReasonPlaceholder = '请输入禁止原因 (选填)'
t.user.errorForbidDate = '请选择禁止到期日'

t.ingredient = {}
t.ingredient.status0 = '停用'
t.ingredient.status1 = '正常'
t.ingredient.status2 = '启用'

t.model = {}
t.model.status0 = '全部'
t.model.status1 = '仅App'
t.model.status2 = '仅英文'
t.model.status3 = '错误'

t.source = {}
t.source.status0 = '批量上传'
t.source.status1 = '管理员上传'
t.source.status2 = '用户上传'
t.source.status3 = '错误'
t.source.status10 = 'UNICORN'

t.statusVModel = {}
t.statusVModel.statusVModel0 = '批量上传'
t.statusVModel.statusVModel1 = ' 管理员上传'
t.statusVModel.statusVModel2 = '审核添加'
t.statusVModel.statusVModel3 = '错误'

t.solid = {}
t.solid.status0 = '1K'
t.solid.status1 = '2K'
t.solid.status2 = '缺失'
t.solid.status3 = '错误'

t.colorSpecial = {}
t.colorSpecial.status0 = '金属/珍珠色'
t.colorSpecial.status1 = '金属色'
t.colorSpecial.status2 = '珍珠色'
t.colorSpecial.status3 = '素色'
t.colorSpecial.status4 = '其他'
t.colorSpecial.status5 = '缺失'
t.colorSpecial.status6 = '错误'

t.recipeType = {}
t.recipeType.status0 = '官方'
t.recipeType.status1 = '服务商'
t.recipeType.status2 = '个人'
t.recipeType.status3 = '缺失'
t.recipeType.status4 = '错误'
t.recipeType.status5 = '现场服务'

t.recipeSource = {}
t.recipeSource.status0 = 'web端'
t.recipeSource.status1 = 'app端'
t.recipeSource.status2 = '缺失'
t.recipeSource.status3 = '错误'
t.recipeSource.status4 = '有效'
t.recipeSource.status5 = '无效'
t.recipeSource.unicorn = 'Unicorn'

t.recipeInfo = {}
t.recipeInfo.upload = '配方批量上传'
t.recipeInfo.result = '上传结果'
t.recipeInfo.submit = '提交'




t.auditCustomized = {}
t.auditCustomized.title = '自定义配方审核'
t.auditCustomized.detail = '自定义配方详情'
t.auditCustomized.audit = '审核'
t.auditCustomized.view = '详情'
t.auditCustomized.massiveAudit = '批量审核'
t.auditCustomized.reject = '拒绝'
t.auditCustomized.requestType0 = '车型'
t.auditCustomized.requestType1 = '品牌-车型'
t.auditCustomized.requestType2 = '色号'
t.auditCustomized.requestType3 = '色号-车型'
t.auditCustomized.requestType4 = '色号-品牌-车型'
t.auditCustomized.requestType5 = '错误'
t.auditCustomized.paintBrand = '油漆品牌'
t.auditCustomized.oem = '制造商'
t.auditCustomized.carBrand = '汽车品牌'
t.auditCustomized.carModel = '汽车型号'
t.auditCustomized.colorCode = '色号'
t.auditCustomized.colorName = '色号名称'
t.auditCustomized.auditStatus = '审核状态'
t.auditCustomized.auditStatus0 = '待审核'
t.auditCustomized.auditStatus1 = '审核通过'
t.auditCustomized.auditStatus2 = '审核拒绝'
t.auditCustomized.auditStatus3 = '审核通过（近似配方）'
t.auditCustomized.officialOem = '官方制造商'
t.auditCustomized.officialCarBrand = '官方汽车品牌'
t.auditCustomized.officialCarModel = '官方汽车型号'
t.auditCustomized.customizedOem = '自定义制造商'
t.auditCustomized.customizedCarBrand = '自定义汽车品牌'
t.auditCustomized.customizedCarModel = '自定义汽车型号'
t.auditCustomized.createUser = '创建人'
t.auditCustomized.createDate = '创建时间'
t.auditCustomized.basicInfo = '基本信息'
t.auditCustomized.carMatrixInfo = '车型信息'
t.auditCustomized.recipeInfo = '配方信息'
t.auditCustomized.requestType = '审核类型'
t.auditCustomized.recipeType = '配方类型'
t.auditCustomized.recipeType1 = '官方配方'
t.auditCustomized.recipeType2 = '现场服务配方'
t.auditCustomized.recipeType3 = '个人上传配方'
t.auditCustomized.recipeSource = '配方来源'
t.auditCustomized.recipeSource1 = 'Web'
t.auditCustomized.recipeSource2 = 'App'
t.auditCustomized.recipeYear = '配方年份'
t.auditCustomized.firstYear = '生效年份'
t.auditCustomized.lastYear = '失效年份'
t.auditCustomized.recipeStatus = '配方状态'
t.auditCustomized.recipeStatus1 = '有效'
t.auditCustomized.recipeStatus0 = '无效'
t.auditCustomized.carAge = '车龄'
t.auditCustomized.carAge0 = '通用'
t.auditCustomized.carAge1 = '1一年以内'
t.auditCustomized.carAge2 = '1-3年'
t.auditCustomized.carAge3 = '3年以上'
t.auditCustomized.colorID = '色号ID'
t.auditCustomized.colorGroup = '颜色组别'
t.auditCustomized.colorNameCn = '颜色名称(中文)'
t.auditCustomized.colorNameEn = '颜色名称(英文)'
t.auditCustomized.colorEffect = '颜色效果'
t.auditCustomized.colorEffect1 = '金属/珍珠'
t.auditCustomized.colorEffect2 = '珍珠'
t.auditCustomized.colorEffect3 = '金属'
t.auditCustomized.colorEffect4 = '素色'
t.auditCustomized.rgb = 'RGB'
t.auditCustomized.rgbPlaceholder = 'rgb_45'
t.auditCustomized.voc = 'VOC'
t.auditCustomized.multiStorey = '是否多层'
t.auditCustomized.multiStorey0 = '否'
t.auditCustomized.multiStorey1 = '是'
t.auditCustomized.recipeProcess = '配方工序'
t.auditCustomized.recipeProcess1 = '第一步'
t.auditCustomized.recipeProcess2 = '第二步'
t.auditCustomized.recipeProcess3 = '第三步'
t.auditCustomized.tinter = '色母'
t.auditCustomized.weight = '重量'
t.auditCustomized.businessCode = '商户代码'
t.auditCustomized.recipeRemark = '配方备注'
t.auditCustomized.auditResult = '审核结果'
t.auditCustomized.auditResult1 = '通过'
t.auditCustomized.auditResult2 = '拒绝'
t.auditCustomized.oemType = '制造商类型'
t.auditCustomized.carBrandType = '汽车品牌类型'
t.auditCustomized.carModelType = '汽车型号类型'
t.auditCustomized.colorCodeType = '色号类型'
t.auditCustomized.existedOem = '已有制造商'
t.auditCustomized.newAddedOem = '新增制造商'
t.auditCustomized.existedCarBrand = '已有汽车品牌'
t.auditCustomized.newAddedCarBrand = '新增汽车品牌'
t.auditCustomized.existedCarModel = '已有汽车型号'
t.auditCustomized.newAddedCarModel = '新增汽车型号'
t.auditCustomized.existedColorCode = '已有色号'
t.auditCustomized.newAddedColorCode = '新增色号'
t.auditCustomized.oemCn = '制造商 (中文)'
t.auditCustomized.oemEn = '制造商 (英文)'
t.auditCustomized.carBrandCn = '汽车品牌 (中文)'
t.auditCustomized.carBrandEn = '汽车品牌 (英文)'
t.auditCustomized.carModelCn = '汽车型号 (中文)'
t.auditCustomized.carModelEn = '汽车型号 (英文)'
t.auditCustomized.auditComments = '审核意见'

t.commercialTenant = {}
t.commercialTenant.name = '名称'
t.commercialTenant.receive_applyfor = '我收到的申请'
t.commercialTenant.receive_send = '我发起的申请'
t.commercialTenant.to_be_confirmed = '待处理'
t.commercialTenant.confirmed = '已同意'
t.commercialTenant.closed_rejected = '已拒绝'
t.commercialTenant.data1 = '申请方名称'
t.commercialTenant.data2 = '申请方类型'
t.commercialTenant.dataName = '处理方名称'
t.commercialTenant.dataCode = '处理方类型'
t.commercialTenant.data3 = '申请关系'
t.commercialTenant.data4 = '申请时间'
t.commercialTenant.data5 = '状态'
t.commercialTenant.data6 = '同意'
t.commercialTenant.data7 = '拒绝'
t.commercialTenant.data8 = '撤回'
t.commercialTenant.data9 = '待处理'
t.commercialTenant.data10 = '已同意'
t.commercialTenant.data11 = '已拒绝'
t.commercialTenant.data12 = '商户关系变更'
t.commercialTenant.data13 = '添加已有商户'
t.commercialTenant.data14 = '商户code'
t.commercialTenant.data15 = '有效'
t.commercialTenant.data16 = '无效'
t.commercialTenant.abbreviation = '简称'
t.commercialTenant.Belong_to = '所属上级'
t.commercialTenant.dealer = '上级经销商'
t.commercialTenant.dealer1 = '所属经销商'
t.commercialTenant.updateDealer = '修改所属经销商'
t.commercialTenant.mso = '上级MSO'
t.commercialTenant.mso1 = '所属MSO'
t.commercialTenant.region = '地区'
t.commercialTenant.regionCountry = '地区'
t.commercialTenant.regionTenant = '商户地址'
t.commercialTenant.mail = '邮箱'
t.commercialTenant.administratorMail = '管理员邮箱'
t.commercialTenant.administratorPhone = '管理员手机号'
t.commercialTenant.phone = '手机号'
t.commercialTenant.paintLineName = '油漆品牌'
t.commercialTenant.select = '请选择'
t.commercialTenant.selectOne = '请至少填写一项'
t.commercialTenant.RepresentativeBASF = '巴斯夫代表（销售）'
t.commercialTenant.RepresentativeBASF1 = '巴斯夫代表'
t.commercialTenant.state0 = '停用'
t.commercialTenant.state1 = '正常'
t.commercialTenant.notAvailable = '暂无'
t.commercialTenant.sendVerificationCode = '发送验证码'
t.commercialTenant.back = '返回'
t.commercialTenant.passwordAssistance = '重置密码'
t.commercialTenant.Mailboxformaterror = '格式错误'
t.commercialTenant.country_data1 = '中国'
t.commercialTenant.country_data2 = '印度'
t.commercialTenant.country_data3 = '印尼'
t.commercialTenant.country_data4 = '马来西亚'
t.commercialTenant.country_data5 = '泰国'
t.commercialTenant.country_data6 = '越南'
t.commercialTenant.country_data7 = '菲律宾'

t.layout_data = {}
t.layout_data.title = '公告标题'
t.layout_data.scope = '公告范围'
t.layout_data.state = '公告状态'
t.layout_data.content = '公告内容'
t.layout_data.home = '首页展示'
t.layout_data.assing = '置顶展示'
t.layout_data.createdtime = '创建时间'
t.layout_data.time = '发布时间'
t.layout_data.noticeTime = '通知时间'
t.layout_data.sendNotice = '发送通知'
t.layout_data.createdperson = '创建人'
t.layout_data.query = '查询'
t.layout_data.add = '新增'
t.layout_data.delete = '删除'
t.layout_data.operate = '操作'
t.layout_data.revamp = '修改'
t.layout_data.issue = '发布'
t.layout_data.china = '国内'
t.layout_data.foreign_country = '亚太'
t.layout_data.upload = '上传图片'
t.layout_data.image_hint = '图片大小建议1080 * 600'
t.layout_data.yes = '是'
t.layout_data.no = '否'
t.layout_data.name = '用户名'
t.layout_data.id = '配方ID'
t.layout_data.commercialTtenant = '所属商户'
t.layout_data.region = '地域'
t.layout_data.date = '反馈日期'
t.layout_data.type = '问题反馈类型'
t.layout_data.dateIssue = '问题反馈时间'
t.layout_data.describe = '反馈问题描述'
t.layout_data.response = '回复内容'
t.layout_data.img = '图片'
t.layout_data.resolved = '已解决'
t.layout_data.unsolved = '未解决'
t.layout_data.state1 = '状态'
t.layout_data.reply = '回复'
t.layout_data.centent = '内容'
t.layout_data.feedbacktype1 = '要求删除配方'
t.layout_data.feedbacktype2 = '配方信息错误'
t.layout_data.feedbacktype3 = '不当评论'
t.layout_data.feedbacktype4 = '积分相关'
t.layout_data.feedbacktype5 = 'App 使用问题及建议'
t.layout_data.feedbacktype6 = '其他'
t.layout_data.feedbacktype7 = '无法识别二维码'
t.layout_data.feedbacktype8 = '摄像头黑屏/打开摄像头失败'
t.layout_data.feedbacktype9 = '无法进入扫码界面'
t.layout_data.feedbacktype10 = '扫码无法获得积分'
t.layout_data.enable_country= '生效国家'
// 用户评论管理
t.layout_data.comment_date = '评论日期'
t.layout_data.state2 = '状态'
t.layout_data.announcement = '置顶公告'


// 轮播图管理
t.banner = {}
t.banner.title = '轮播图{number}'

// 用户评论管理
t.user_comment = {}
t.user_comment.comment_time = '评论时间'
t.user_comment.user_name = '用户名'
t.user_comment.merchant = '所属商户'
t.user_comment.region = '地域'
t.user_comment.score = '评分'
t.user_comment.content = '评论内容'
t.user_comment.imgs = '评论图片'
t.user_comment.formula = '评论配方'
t.user_comment.status = '状态'
t.user_comment.effective = '有效'
t.user_comment.invalid = '无效'
t.user_comment.shield = '屏蔽'
t.user_comment.restore = '恢复'


t.gift = {}
t.gift.upload = '上传'
t.gift.uploadPicture = '上传图片'
t.gift.status0 = '下架'
t.gift.status1 = '上架'
t.gift.operationFailed = '操作失败'
t.gift.giftName = '礼品名称'
t.gift.giftDescription = '描述'
t.gift.giftImgUrl = '图片URL'
t.gift.giftCost = '兑换积分'
t.gift.giftInventory = '剩余库存'
t.gift.giftOriginalInventory = '初始库存'
t.gift.giftId = '礼品ID'
t.gift.giftStatus = '状态'

t.redemption = {}
t.redemption.status0 = '失效'
t.redemption.status1 = '激活'
t.redemption.save = '保存'
t.redemption.startDateInvalid = '开始日期无效'
t.redemption.endDateInvalid = '结束日期无效'
t.redemption.startDateMustBeBeforeEndDate = '兑换活动开始日期必须早于兑换活动结束日期'
t.redemption.startDateMustBeAfterToday = '当前时间必须早于兑换活动开始日期.'
t.redemption.endDateMustBeAfterToday = '结束日期必须晚于当前时间'
t.redemption.giftSelectionPromptRequired = '必填项不能为空'
t.redemption.submissionPromptRequired = '必填项不能为空'
t.redemption.allFieldsRequired = '必填项不能为空'
t.redemption.dataNotSaved = '保存失败'
t.redemption.currentStatus = '当前状态'
t.redemption.saveToViewPicture = '图片保存后将更新...'
t.redemption.period = '有效日期'
t.redemption.banner = '展示图片'
t.redemption.pictureUrl = '图片URL'
t.redemption.giftSelectionPrompt = '选择礼品后提示语'
t.redemption.submissionPrompt = '提交信息后提醒语'
t.redemption.status = '状态'
t.redemption.displayedApp  = 'App显示'

t.activitysetting = {}
t.activitysetting.startDateMustBeAfterToday='当前时间必须早于活动开始日期'
t.activitysetting.startDateMustBeBeforeEndDate='活动开始日期必须早于活动结束日期'

t.orders = {}
t.orders.orderId = '订单ID'
t.orders.status0 = '待发货'
t.orders.status1 = '已发货'
t.orders.status2 = '被用户取消'
t.orders.status3 = '被管理员取消'
t.orders.ship = '发货'
t.orders.revert = '恢复' // not in used at the moment
t.orders.cancel = '取消'
t.orders.cancelReason = '取消原因'
t.orders.reason = '原因'
t.orders.isShippedOrCancelled = '订单已发货或已取消'
t.orders.confirmShip = '发货订单ID'
t.orders.confirmShipping = '确认发货'
t.orders.contact = '联系方式'
t.orders.userName = '用户名'
t.orders.giftId = '礼品ID'
t.orders.giftName = '礼品名称'
t.orders.redeemDate = '兑换日期'
t.orders.receiverName = '收货人姓名'
t.orders.shippingAddress = '收货地址'
t.orders.giftCost = '兑换积分值'
t.orders.orderStatus = '订单状态'
t.orders.cancelReason = '取消原因'
t.orders.amount = '兑换数量'

t.point = {}
t.point.point = "积分"
t.point.distributorUserPointAccrual = "经销商用户积分配置"
t.point.adjustPoints = '调整积分'
t.point.userName = '用户名'
t.point.merchantName = '所属商户'
t.point.provinceName = '地区'
t.point.userMobileNumber = '手机号'
t.point.userRealName = '真实姓名'
t.point.roleName = '角色'
t.point.pointBalance = '当前积分'
t.point.remarks = '备注'
t.point.exampleInput = '例10, -100, 250, -50'

t.general = {}
t.general.uploadFailed = '上传失败'
t.general.noPicture = '暂无图片'
t.general.statusInvalid = '无效状态'
t.general.noData = '暂无数据'
t.general.invalidUserId = '无效用户ID'
t.general.uploadingPicture = '上传图片中...'
t.general.pictureUrl = '图片URL'
t.general.startDate = '开始日期'
t.general.endDate = '结束日期'
t.general.to = '至'

t.userAudit = {}
t.userAudit.username = '用户名'
t.userAudit.realName = '真实姓名'
t.userAudit.mobile = '手机号'
t.userAudit.status = '状态'
t.userAudit.status0 = '待审核'
t.userAudit.status1 = '审核通过'
t.userAudit.status2 = '审核拒绝'
t.userAudit.regiestDate='注册时间'
t.userAudit.comTypeName='单位类型'
t.userAudit.comName='单位名称'
t.userAudit.province='省份'
t.userAudit.addr='单位地址'
t.userAudit.provider='产品供应商'
t.userAudit.audit='审核'
t.userAudit.auditReslut='审核结果'
t.userAudit.auditTitle='用户审核'

t.recipeCollection = {}
t.recipeCollection.defaultSetting = '默认配置'
t.recipeCollection.paintBrand = '油漆品牌'
t.recipeCollection.oem = '制造商'
t.recipeCollection.carBrand = '汽车品牌'
t.recipeCollection.carModel = '汽车型号'
t.recipeCollection.colorCode = '色号'
t.recipeCollection.colorName = '色号名称'
t.recipeCollection.collectStatus = '征集状态'
t.recipeCollection.collectStatus0 = '草稿'
t.recipeCollection.collectStatus1 = '已发布'
t.recipeCollection.collectStatus2 = '征集完成'
t.recipeCollection.collectStatus3 = '人工下架'
t.recipeCollection.collectionProgress = '征集进度'
t.recipeCollection.bonusPoint = '奖励积分'
t.recipeCollection.publishTime = '发布时间'
t.recipeCollection.edit = '编辑'
t.recipeCollection.publish = '发布'
t.recipeCollection.delete = '删除'
t.recipeCollection.manualRemove = '人工下架'
t.recipeCollection.view = '详情'
t.recipeCollection.collectNum = '征集数量'
t.recipeCollection.needVerify = '人工审核'
t.recipeCollection.topCollection = '紧急征集'
t.recipeCollection.audit = '审核'
t.recipeCollection.auditStatus = '审核状态'
t.recipeCollection.auditStatus0 = '待审核'
t.recipeCollection.auditStatus1 = '审核通过'
t.recipeCollection.auditStatus2 = '审核拒绝'
t.recipeCollection.verifyStatus = '审核结果'
t.recipeCollection.verifyStatus1 = '批准'
t.recipeCollection.verifyStatus2 = '拒绝'
t.recipeCollection.verifyComment = '审核意见'
t.recipeCollection.back = '返回'
t.recipeCollection.input = '请输入'
t.recipeCollection.uploadTime = '上传时间'
t.recipeCollection.uploadUser = '上传用户'
t.recipeCollection.recipeId = '配方ID'
t.recipeCollection.publishConfirm = '发布配方征集'
t.recipeCollection.formulaType = '配方类型'
t.recipeCollection.customizedType0 = '普通配方'
t.recipeCollection.customizedType1 = '自定义车型配方:待审核'
t.recipeCollection.customizedType2 = '自定义车型配方：审核通过'
t.recipeCollection.customizedType3 = '自定义车型配方：审核拒绝'
t.recipeCollection.customizedType4 = '自定义车型配方：审核通过（近似配方）'

t.pointRule = {}
t.pointRule.pointRuleEnabledCountry = '国家'
t.pointRule.pointRuleCountryTip = 'BASF内部用户无法获得积分'

t.pointRule.pointRuleIntro = '上传积分规则'
t.pointRule.pointRuleAccrualRelatedToFormulas = '配方相关积分'
t.pointRule.pointRuleAccrualRelatedToScan = '扫码积分'
t.pointRule.pointRuleAccrualRelatedToTechnicalAssessment = '技术测评奖励'

t.pointRule.pointRuleReferralBonusTitle = '推荐邀请奖励'
t.pointRule.pointRuleReferralBonusEarn ="获得"
t.pointRule.pointRuleReferralBonusEarnEnd ="% 邀请认证用户的配方上传奖励积分(包含征集配方奖励)."
t.pointRule.pointRuleReferralScanCode ="获得"
t.pointRule.pointRuleReferralScanCodeEnd ="% 邀请认证用户的扫码防伪二维码奖励积分"

t.pointRule.pointRuleUploadingFormulasTip = '用户可以在上传配方之后再补充上传配方图片获得额外积分，但每个配方最多获取一次'
t.pointRule.pointRuleUploadingFormulasTitle ="上传配方"
t.pointRule.pointRuleUploadingFormulasWillEarn ="上传配方获得"
t.pointRule.pointRuleUploadingFormulasPoints ="分"
t.pointRule.pointRuleUploadingFormulasAdditionally="上传配方时，上传配方图片额外获得"

t.pointRule.pointRuleInteractingTitle = "配方互动"
t.pointRule.pointRuleInteractingTip = '同一个用户对同一个配方进行评分、文本评分、图片评论，无法多次获得积分'
t.pointRule.pointRuleInteractingTip1 = '不支持用户对自己的配方评论获得积分'
t.pointRule.pointRuleInteractingPointRatingOther = "对其他用户的配方进行评分，可获得"
t.pointRule.pointRuleInteractingPointRatingOtherCountPoint = "分，每天最多可获得"
t.pointRule.pointRuleInteractingPointRatingOtherDayPoint = "分，每月最多可获得"
t.pointRule.pointRuleInteractingPointRatingOtherMonthPoint = "分"
t.pointRule.pointRuleInteractingContentPointRatingOtherMonthPoint = "对其他用户的配方进行评论时填写文本内容，可获得"
t.pointRule.pointRuleInteractingImgRatingOtherMonthPoint = "对其他用户的配方进行评论时上传图片，可获得"

t.pointRule.pointRuleInteractingOthenUserTitle = "其他用户与配方互动"
t.pointRule.pointRuleInteractingOthenUserTip = '同一用户重复使用、收藏、评论同一配方，不会获得额外积分'
t.pointRule.pointRuleInteractingOthenUserTip1 = '使用配方:其他用户查看并调整你的配方'
t.pointRule.pointRuleInteractingOthenUserUseFormulas="使用配方奖励:其他用户使用配方时，配方上传人可获得"
t.pointRule.pointRuleInteractingOthenUserUseFormulasPoints = "分，单个配方最多可获得"
t.pointRule.pointRuleInteractingOthenUserUseFormulasMaxPoints = "分"
t.pointRule.pointRuleInteractingOthenUserCollectFormulas="收藏配方奖励:其他用户收藏配方时，配方上传人可获得"
t.pointRule.pointRuleInteractingOthenUserCollectFormulasPoints = "分，单个配方最多可获得"
t.pointRule.pointRuleInteractingOthenUserCollectFormulasMaxPoints = "分"
t.pointRule.pointRuleInteractingOthenUserScoreMin="评论配方奖励:其他用户对评论配方时并目评分大于等于"
t.pointRule.pointRuleInteractingOthenUserScorePoints = ", 配方上传人可获得"

t.pointRule.pointRuleTechnicalAssessmentTitle = "技术评估"
t.pointRule.pointRuleTechnicalAssessmenteExam = "通过考试后，您将获得"

t.pointRule.pointRuleScanCodeTitle = "扫码"
t.pointRule.pointRuleScanCodeSuccess = "成功扫描并验证防伪二维码后，您将获得"

t.pointRule.pointRuleScanCodeExtraTitle = "扫码(Extra rule)"
t.pointRule.pointRuleScanCodeExtraRuleTime = "规则时间："
t.pointRule.pointRuleScanCodeExtraRuleBeginTime = "开始时间"
t.pointRule.pointRuleScanCodeExtraTo = "至"
t.pointRule.pointRuleScanCodeExtraRuleEndTime = "结束时间"
t.pointRule.pointRuleScanCodeExtraPaintBrand = "品牌："
t.pointRule.pointRuleScanCodeExtraPaintline = "产品线："
t.pointRule.pointRuleScanCodeExtraSKU = "SKU："
t.pointRule.pointRuleScanCodeExtraPoints = "额外积分："


// 学习资料管理form表单
t.learning_materials = {}
t.learning_materials.name = '资料名称'
t.learning_materials.range = '资料范围'
t.learning_materials.directory = '一级目录'
t.learning_materials.paint_brand= '油漆品牌'
t.learning_materials.status= '资料状态'
t.learning_materials.query = 'Search'
t.learning_materials.add = 'Add'
t.learning_materials.delete = '删除'


t.learning_materials.china = '国内'
t.learning_materials.foreign_country = '亚太'
t.learning_materials.knowledge = '技术资料'
t.learning_materials.technique = '施工视频'
t.learning_materials.technology = '涂料知识'
t.learning_materials.foreign_country = '亚太'
t.learning_materials.foreign_country = '亚太'
t.learning_materials.released = '待发布'
t.learning_materials.published = '已发布'
t.learning_materials.withdrawn = '已撤回'


t.learning_materials.img = '展示图片'
t.learning_materials.pdf = 'PDF资源'
t.learning_materials.material_name = '资料名称'
t.learning_materials.material_introduce = '资料介绍'
t.learning_materials.material_range = '资料范围'
t.learning_materials.material_brand = '油漆品牌'
t.learning_materials.material_directory = '一级目录'
t.learning_materials.material_status = '资料状态'
t.learning_materials.material_release_time = '发布时间'
t.learning_materials.material_create_time = '创建时间'
t.learning_materials.material_create = '创建人'
t.learning_materials.operate = '操作'
t.learning_materials.revamp = '修改'
t.learning_materials.release = '发布'
t.learning_materials.withdraw = '撤回'
t.learning_materials.paint_brand1 = '诺缤'
t.learning_materials.paint_brand2 = '闪彩'
t.learning_materials.video_link = '视频链接'
t.learning_materials.delete_image = '请先删除图片再重新上传'
//消息推送
t.userMsg = {}
t.userMsg.title = '消息标题'
t.userMsg.content = '消息内容'
t.userMsg.target = '推送对象'
t.userMsg.type = '消息类型'
t.userMsg.status = '消息状态'
t.userMsg.allUsers = '全部用户'
t.userMsg.specificUsers = '指定用户'
t.userMsg.userIdsPlaceholder = '请输入用户ID，多个请用逗号分割'
t.userMsg.userIdsFormatError = '用户ID格式不正确，请使用逗号分割'
t.userMsg.publishDate = '发布时间'
t.userMsg.createDate = '创建日期'
t.userMsg.statusDraft = '待发布'
t.userMsg.statusPublished = '已发布'
t.userMsg.pstartDate = "发布开始时间"
t.userMsg.pendDate = "发布结束时间"
t.userMsg.cstartDate = "创建开始时间"
t.userMsg.cendDate = "创建结束时间"
t.userMsg.publish = '发布'
t.userMsg.receiveUserIdsFormatError = '接收用户ID格式不正确，请使用逗号分割'
t.userMsg.publishConfirm = '确认发布'
t.userMsg.publishSuccess = '发布成功'
export default t
